import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {isEmpty} from 'lodash/lang';
import {RemoveRedEye as RemoveRedEyeIcon} from '@material-ui/icons';
import {withKluwellTableWrapper, KluwellTableCore, SortingManager} from 'components/common';
import {levelMap} from 'utils/common';

const buildAwardRecords = (awards) => {
  const sortedIds = awards.sortedIds || [];
  return isEmpty(sortedIds)
    ? []
    : sortedIds.map((awardId) => {
        const award = awards[awardId];
        return {
          id: awardId,
          title: award.title,
          points: award.points,
          level: levelMap[award.level],
          image: `${process.env.SERVER_BASE_URL}${award.image}`,
          actions: '',
        };
      });
};

const buildAwardSettings = () => ({
  title: {
    fieldText: 'Title',
    sortable: true,
  },
  points: {
    fieldText: 'Reading Nights',
  },
  level: {
    fieldText: 'Level',
  },
  image: {
    fieldText: 'Image',
    formatData: (cell) => <img src={cell} />,
  },
  actions: {
    fieldText: 'Actions',
    formatData: (cell, row) => (
      <Link to={`/awards/${row.id}`} title="view">
        <RemoveRedEyeIcon />
      </Link>
    ),
  },
});

class AwardTableCore extends React.Component {
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    onSortableFieldClick: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      awardToDelete: {},
    };
    this.sortingManager = new SortingManager();
  }

  render() {
    const {recordPages, onSortableFieldClick, hiddenFields} = this.props;
    const awards = recordPages[recordPages.currentPage] || {};
    const records = buildAwardRecords(awards);
    const settings = buildAwardSettings();
    return (
      <KluwellTableCore
        {...{
          records,
          settings,
          sortingManager: this.sortingManager,
          onSortableFieldClick,
          hiddenFields,
        }}
      />
    );
  }
}

export default withKluwellTableWrapper(AwardTableCore);
